'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var _frFR = require('./icons/fr-FR');

var _frFR2 = _interopRequireDefault(_frFR);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _extends({
  IndexFilters: {
    filters: '{quantity, plural,\n  =0 {Filtres}\n  =1 {un filtre}\n  ' + 'other {# filtres}\n}'
  }
}, _frFR2.default, {
  Active: 'Actif',
  Activate: 'Activé',
  Activated: 'Est Actif',
  Add: 'Ajouter',
  add: 'ajouter',
  Alerts: 'Alertes',
  All: 'Tout',
  ampm: 'ampm',
  Arc: 'Arc',
  AxisLabel: '{orientation} Axe',
  area: 'zone',
  Bar: 'Barre',
  bar: 'barre',
  Blank: 'Vide',
  Box: 'Cadre',
  Carousel: 'Carousel',
  Category: 'Catégorie',
  Circle: 'Cercle',
  Chart: 'Diagramme',
  Children: 'Enfant',
  Clear: 'Nettoyer',
  Cleared: 'Nettoyé',
  Close: 'Fermer',
  'Close Menu': 'Fermer le menu',
  Completed: 'Completer',
  'Connects With': 'Se connecte avec',
  created: 'Créer',
  Critical: 'Critique',
  'Currently Active': 'Actuellement Actif',
  'Date Selector': 'Sélecteur de date',
  'Date Time Icon': 'Ouvrir le sélecteur de date et heure',
  day: 'jour',
  Disabled: 'Désactivé',
  Distribution: 'Distribution',
  Email: 'Courriel',
  'Enter Select': 'Appuyer sur entrer pour sélectionner',
  Error: 'Erreur',
  Filter: 'Filtre',
  Footer: 'Pied de page',
  Grommet: 'Grommet',
  HotSpotsLabel: 'HotSpots: press arrow keys to interact with it',
  'GraphValues': 'Le graphique a {count} articles. Le plus grand est {highest}' + ' le plus petit est {smallest}',
  hour: 'heure',
  'Grommet Logo': 'Logo de Grommet',
  'Layer': 'Calque',
  List: 'Liste',
  line: 'ligne',
  'Loading': 'Chargement',
  loginInvalidPassword: 'Veuillez entrer un nom d\'utilisateur et un mot de passe.',
  'Log In': 'Connexion',
  Logout: 'Déconnexion',
  'Main Content': 'Contenu principal',
  Max: 'Max',
  Menu: 'Menu',
  Meter: 'Mètre',
  Min: 'Min',
  minute: 'minute',
  model: 'Modèle',
  modified: 'Modifié',
  monitor: 'moniteur',
  month: 'mois',
  'Multi Select': 'Sélection multiple',
  Name: 'Nom',
  'Navigation Help': 'Utilisez les flèches pour naviguer',
  'Next Month': 'Mois Suivant',
  'Next Slide': 'Fiche Suivante',
  'No Relationship': 'Aucun relation',
  'Notification': 'Notification',
  OK: 'OK',
  Open: 'Ouvrir',
  Parent: 'Parent',
  Parents: 'Parents',
  Parts: 'Parties',
  Part: 'Partie',
  Password: 'Mot de passe',
  'Previous Month': 'Mois Précédent',
  'Previous Slide': 'Fiche Précédente',
  'Previous Tiles': 'Tuiles Précédentes',
  'Remember me': 'Se souvenir de moi',
  'Range Start': 'Début de l\'intervalle',
  'Range End': 'Fin de l\'intervalle',
  Resource: 'Ressource',
  Running: 'En marche',
  Search: 'Recherche',
  'Match Results': 'Il {count, plural,\n      =0 {n\'y a aucun r\xE9sultat}\n      one {y a # r\xE9sultat}\n      other {y a # r\xE9sultats}\n  }',
  second: 'seconde',
  'Select Icon': 'Ouvrir le sélecteur déroulant',
  Selected: 'Sélectionné',
  'Selected Multiple': '{count, plural,\n      =0 {aucune}\n      one {# valeur}\n      other {# valeurs}\n  }',
  'Skip to': 'Aller à',
  'Slide Number': 'Fiche {slideNumber}',
  Sort: 'Classer',
  Spinning: 'Rotation',
  Spiral: 'Spirale',
  State: 'État',
  Status: 'Status',
  Subtract: 'Soustraire',
  SunBurst: 'Graphique en rayons de soleil',
  'Tab Contents': '{activeTitle} Contenu de l\'onglet',
  Table: 'Tableau',
  Tasks: 'Tâches',
  Tiles: 'Tuiles',
  Time: 'Temps',
  Title: 'Titre',
  Today: 'Aujourd\'hui',
  Topology: 'Topologie',
  Total: 'Totale',
  Threshold: 'Seuil',
  Unknown: 'Inconne',
  Username: 'Nom d\'utilisateur',
  uri: 'URI',
  Value: 'Valeur',
  Warning: 'Avertissement',
  year: 'année'
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/grommet/messages/fr-FR.js
// module id = 99
// module chunks = 114276838955818